App.BackEmailFinder = function () {
  return {
    submit() {
      this.displayLoader();
      this.domain = $("#domain-field").val();
      this.full_name = $("#full-name-field").val();

      // Reactivate the autocomplete
      this.configureAutoComplete();

      // Not correct domain -> STOP
      if ((this.domain.length < 4) || (this.domain.indexOf(".") === -1)) {
        App.displayFlash("danger", i18n.t("js.front.email_finder.not_correct_domain_name"));
        this.hideLoader();
        return false;
      }

      // Clean the domain
      this.domain = App.hostnameFromURL(this.domain);
      $("#domain-field").val(this.domain);

      return this.loadResults();
    },

    loadResults() {
      this.cleanFinderResults()

      if (typeof $("#full-name-field").data("bs.tooltip") !== "undefined") {
        $("#full-name-field").tooltip("destroy")
      }

      let resultsFrame = document.getElementById("email_finder")
      let url = App.api.findEmail(this.domain, this.full_name, "html")
      resultsFrame.src = url
      resultsFrame.reload()

      const _this = this

      // When the frame is loaded
      resultsFrame.loaded.then(function () {
        _this.hideLoader()

        initializeEmailFinder(false)

        // Copy button function
        App.copyEmailListener()

        _this.configureAutoComplete()
      })
    },

    // Enables the autocomplete for the search field.
    configureAutoComplete() {
      return $("#domain-field").autocomplete({
        noCache: false,
        minChars: 3,
        preserveInput: true,
        lookup(query, done) {
          const items = [];

          const input = App.hostnameFromURL(query);
          if (input === "") {
            return done({ suggestions: items });
          }

          return $.getJSON(App.api.domainsSuggestion(input), function (result) {
            result.data.forEach(function (item) {
              items.push({
                value: item.name,
                data: item.domain,
                logo: `https://company-logo.hunter.io/${item.domain}`
              })
            });

            done({ suggestions: items });
          });
        },

        formatResult(suggestion, currentValue) {
          // Highlight the string already typed.
          const dataHighlighted = suggestion.data.replace(currentValue.toLowerCase(), `<span class='suggestion-data-highlight'>${currentValue.toLowerCase()}</span>`);

          let companyName = ""
          if (suggestion.value !== "") {
            companyName = ` <span class="autocomplete-value">${suggestion.value}</span> `;
          }

          return `<span class="autocomplete-logo"><img src="${suggestion.logo}" onerror="this.src='/images/default_company_logo.svg'" /></span><span class="autocomplete-value">${companyName}</span><span class="autocomplete-data">${dataHighlighted}</span>`
        },

        onSelect(suggestion) {
          $("#domain-field").val(suggestion.data);
          $("#domain-field").autocomplete("destroy");

          if ($("#domain-field").val().length && $("#full-name-field").val().length) {
            return $("#finder-form").trigger("submit");
          }
        }
      });
    },

    displayLoader() {
      const btn = $("#finder-btn");
      const width = btn.outerWidth();
      btn.css("width", width + "px");
      btn.prop("disabled", true);
      btn.html("<span class='far fa-spinner-third fa-spin'></span>");
    },

    hideLoader() {
      const btn = $("#finder-btn");
      btn.prop("disabled", false);
      btn.html(`<span class="hidden-xs">${i18n.t("js.find")}</span><span class="visible-xs-block far fa-search"></span>`);
    },

    cleanFinderResults() {
      $(".finder-result").html("").hide();
      $(".finder-no-result").html("").hide();
      $(".ds-more-results").html("").hide();
    },
  };
};

function initializeEmailFinder(prelaunch) {
  if (!App.currentPageIs("email_finder", "index")) { return; }

  const emailFinder = new App.BackEmailFinder();
  emailFinder.configureAutoComplete();

  if (prelaunch && $("#domain-field").val().length && $("#full-name-field").val().length) {
    emailFinder.submit();
  }

  $("#finder-form").on("submit", function (e) {
    e.preventDefault();
    return emailFinder.submit();
  });

  // Remove the current logo when user type a new domain
  $("#domain-field").on("input", function () {
    if ($(this).val().length <= 1) {
      $(".ds-search-result__logo").attr("src", $(".ds-search-result__logo").data("default-logo"))
    }
  })

  // Jump to Domain field when @ is pressed
  $("#full-name-field").on("keydown", function (e) {
    if (e.key === "@") {
      e.preventDefault()

      $("#domain-field").focus()
    }
  })
}

document.addEventListener("turbo:load", function () { initializeEmailFinder(true) });

// Some elements can be in the cache of Turbo, but we don't want them to be
// displayed and just normally load after if they have to.
//
document.addEventListener("turbo:before-cache", function () {
  if (!App.currentPageIs("email_finder", "index")) { return; }

  // Clean the Email Finder
  const backEmailFinder = new App.BackEmailFinder()
  backEmailFinder.cleanFinderResults()
  $("#domain-field").val("")
  $("#full-name-field").val("")
  return $(".finder-message").show()
})
